module.exports = __webpack_public_path__ + "img/140.2.8a021d89.png";